import { useState, useEffect } from "react";
import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Box, IconButton, Typography } from "@mui/material";
import Item from "../adminComponents/Item";
import TextsmsOutlinedIcon from "@mui/icons-material/TextsmsOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import PaidIcon from "@mui/icons-material/Paid";
import secureLocalStorage from "react-secure-storage";

const SideBar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selected, setSelected] = useState("");
  const role = secureLocalStorage.getItem("role");
  console.log(role);

  return (
    <Box style={{ borderRight: "1px solid rgba(255, 255, 255, 0.2)" }}>
      <Sidebar
        collapsed={isCollapsed}
        backgroundColor="var(--dark-purple)"
        style={{ borderColor: "var(--dark-purple)" }}
      >
        <Menu
          iconShape="square"
          menuItemStyles={{
            button: {
              "&:hover": {
                transition: "transform 0.5s ease",
                transform: "translateX(1vw)",
                color: "var(--white)",
              },
            },
          }}
        >
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
            style={{
              margin: "1vw 0 2vw 0",
              background: "var(--dark-purple)",
              color: "var(--red)",
            }}
          >
            {!isCollapsed && (
              <Box
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
                ml="1.4vw"
              >
                <IconButton
                  onClick={() => setIsCollapsed(!isCollapsed)}
                  sx={{ color: "var(--color-grey-light)" }}
                >
                  <MenuOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>
          {!isCollapsed && (
            <Box mb="2.4vw">
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <img
                  width="70vw"
                  alt="Logo"
                  src="\project-logo.png"
                  style={{ cursor: "pointer", marginLeft: "0.4vw" }}
                />
                <Typography
                  variant="h5"
                  color={"var(--red)"}
                  sx={{ fontWeight: 800, mr: "1.2vw" }}
                >
                  Forex Miner
                </Typography>
              </Box>
            </Box>
          )}
          {role === "admin" ? (
            <Box paddingLeft={isCollapsed ? undefined : "10%"}>
              <Item
                title="Dashboard"
                to="/admin"
                icon={<HomeOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              <Item
                title="Subscriber"
                to="/admin/subscribers"
                icon={
                  <img
                    alt="Logo"
                    src={`/bell${selected === "Subscriber" ? "2" : "1"}.png`}
                    style={{ cursor: "pointer" }}
                  />
                }
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                title="Query"
                to="/admin/queries"
                icon={<TextsmsOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                title="FAQs"
                to="/admin/faqs"
                icon={<HelpOutlineOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                title="Subscriptions"
                to="/admin/plans"
                icon={<FactCheckOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />
            </Box>
          ) : (
            <Box paddingLeft={isCollapsed ? undefined : "10%"}>
              <Item
                title="Dashboard"
                to="/subscriber"
                icon={<HomeOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                title="Plan"
                to="/subscriber/plan/view"
                icon={<PaidIcon />}
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                title="Query"
                to="/subscriber/query/create"
                icon={<TextsmsOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />
            </Box>
          )}
        </Menu>
      </Sidebar>
    </Box>
  );
};

export default SideBar;
